<template>
  <v-row class="pa-5" v-if="attributes">
    <v-col cols="12">
      <h2>Attributes Table</h2>
    </v-col>
    <v-col cols="11">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>
                Title
              </th>
              <th>
                Description
              </th>
              <th>
                Proof points
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, count) in attributes"
              :key="`${item.title}-${count}`"
            >
              <td class="py-4">
                <h2>{{ item.title }}</h2>
              </td>
              <td class="py-4">
                {{ item.description }}
              </td>
              <td class="py-4">
                <ul>
                  <li
                    v-for="(sub, count) in item.items"
                    :key="`${index}-${count}`"
                  >
                    {{ sub }}
                  </li>
                </ul>
                <!-- <v-chip
                  v-for="(sub, count) in item.items"
                  :key="`${index}-${count}`"
                  class="ma-1"
                  :class="item.color"
                >
                  {{ sub }}
                </v-chip> -->
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsAttributesTable",
  data() {
    return {
      doc: null,
      attributes: [],
      dialog: false,
    };
  },
  props: {
    uid: String,
    id: String,
    model: String,
    lang: String,
  },
  mounted() {
    this.getAttributes();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAttributes() {
      console.log("get attributes");
      let ref = fb.attributesPt1ExCollection.where("pid", "==", this.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let post = docs.data();
          post.doc.attributes.forEach((benefit) => {
            items.push(benefit);
          });
        });
        this.attributes = items;
      });
    },
  },
};
</script>
